import React from 'react'

  function Four04() {
    return (
      <div>
        <section className="internal-page-wrapper top-100 bottom-100">
            <div className="container">
              <div className="row h-100 align-items-center justify-content-center text-center">
                <div className="col-12">
                  <h1>
                  <br/>
                    The page you’re looking for can’t be found.</h1>
                </div>
              </div>
            </div>
          </section>
      </div>
    )
  }

  export default Four04
